import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  Typography,
  FormControl,
  Select,
  MenuItem,
  CircularProgress,
} from '@mui/material';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import ManagingCommitteeDisplay from '../../components/ManagingCommitteeDisplay';

const getCurrentFinancialYear = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth() + 1;
  return month < 4 ? `${year-1}-${year}` : `${year}-${year+1}`;
};

const generateFinancialYears = () => {
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let year = 2011; year <= currentYear; year++) {
    years.unshift(`${year}-${year + 1}`);
  }
  return years;
};

function ManagingCommittee() {
  const [members, setMembers] = useState([]);
  const [selectedYear, setSelectedYear] = useState(getCurrentFinancialYear());
  const [loading, setLoading] = useState(true);
  const [availableYears, setAvailableYears] = useState([]);

  // Fetch all available years
  useEffect(() => {
    const fetchAvailableYears = async () => {
      try {
        const years = generateFinancialYears();
        const availableYearsData = [];
        
        for (const year of years) {
          const docRef = doc(db, 'managingCommittee', year);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists() && docSnap.data().members?.length > 0) {
            availableYearsData.push(year);
          }
        }

        setAvailableYears(availableYearsData);
        if (availableYearsData.length > 0 && !availableYearsData.includes(selectedYear)) {
          setSelectedYear(availableYearsData[0]);
        }
      } catch (error) {
        console.error('Error fetching available years:', error);
      }
    };

    fetchAvailableYears();
  }, []);

  // Fetch members for selected year
  useEffect(() => {
    const fetchMembers = async () => {
      try {
        setLoading(true);
        const docRef = doc(db, 'managingCommittee', selectedYear);
        const docSnap = await getDoc(docRef);
        
        if (docSnap.exists()) {
          setMembers(docSnap.data().members || []);
        } else {
          setMembers([]);
        }
      } catch (error) {
        console.error('Error fetching members:', error);
      } finally {
        setLoading(false);
      }
    };

    if (selectedYear) {
      fetchMembers();
    }
  }, [selectedYear]);

  return (
    <Box sx={{ py: 4 }}>
      <Container maxWidth="lg">
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
          <Typography
            component="h1"
            variant="h4"
            sx={{ fontWeight: 600, color: '#580100' }}
          >
            Managing Committee
          </Typography>
          
          <FormControl sx={{ minWidth: 200 }}>
            <Select
              value={selectedYear}
              onChange={(e) => setSelectedYear(e.target.value)}
              size="small"
              sx={{
                '& .MuiSelect-select': {
                  color: '#580100',
                  fontWeight: 500
                }
              }}
            >
              {availableYears.map((year) => (
                <MenuItem key={year} value={year}>{year}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
            <CircularProgress />
          </Box>
        ) : (
          <ManagingCommitteeDisplay members={members} showContactInfo={true} showCoOptedMembers={true} />
        )}
      </Container>
    </Box>
  );
}

export default ManagingCommittee;